// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['fa_IR']  = { // eslint-disable-line import/no-commonjs
  name: 'fa_IR',
  day: {
    abbrev: [
      'یکشنبه',
      'دوشنبه',
      'سه شنبه',
      'چهارشنبه',
      'پنجشنبه',
      'جمعه',
      'شنبه'
    ],
    full: [
      'یکشنبه',
      'دوشنبه',
      'سه شنبه',
      'چهارشنبه',
      'پنجشنبه',
      'جمعه',
      'شنبه'
    ]
  },
  month: {
    abbrev: [
      'ژانویه',
      'فوریه',
      'مارس',
      'آوریل',
      'مه',
      'ژوئن',
      'ژوییه',
      'آگوست',
      'سپتامبر',
      'اکتبر',
      'نوامبر',
      'دسامبر'
    ],
    full: [
      'ژانویه',
      'فوریه',
      'مارس',
      'آوریل',
      'مه',
      'ژوئن',
      'ژوییه',
      'آگوست',
      'سپتامبر',
      'اکتبر',
      'نوامبر',
      'دسامبر'
    ]
  },
  meridiem: ['قبل از ظهر', 'بعد از ظهر'],
  date: '%d/%m/%Y',
  time24: '%T',
  dateTime: '%a %d %b %Y %T %Z',
  time12: '',
  full: '%a %b %e %H:%M:%S %Z %Y'
}

